<script lang="ts">
    import appStore from "@/utils/store";
    import { goTo } from "@/utils/router";
    import { translate } from "@/utils/format";

    import CreativeGenerator from "@/components/custom/creativeGenerator/App.svelte";

    const user = appStore.get("user") || null;

    const referralCode = String(user?.referralCode || user?.id || "").trim();
    const referralLink = referralCode
        ? `https://link.caloo.app/r/${referralCode}`
        : "";

    const partnerLogo = String(user?.logo || user?.image || "");

    function close() {
        goTo("/dashboard");
    }
</script>

<section class="creativityPage">
    <header class="creativityPage__header">
        <button
            class="creativityPage__back"
            type="button"
            onclick={close}
            aria-label={translate("PARTNER_BACK", "Volver")}
        >
            <i class="fal fa-arrow-left"></i>
            <span>{translate("PARTNER_BACK", "Volver")}</span>
        </button>

        <div class="creativityPage__title">
            <h1>
                {translate(
                    "PARTNER_CREATIVITIES_TITLE",
                    "Generar creatividades",
                )}
            </h1>
            <p>
                {translate(
                    "PARTNER_CREATIVITIES_DESC",
                    "Crea imágenes promocionales con tu QR y tu logo para compartir en redes.",
                )}
            </p>
        </div>
    </header>

    {#if !referralLink}
        <div class="creativityPage__empty">
            <h2>{translate("EMPTY_STATE_NO_DATA", "Sin datos")}</h2>
            <p>
                {translate(
                    "PARTNER_CREATIVITIES_NEED_CODE",
                    "No pudimos generar tu enlace de referido. Vuelve al panel y revisa tu código.",
                )}
            </p>
            <button class="button --primary" type="button" onclick={close}>
                {translate("PARTNER_BACK_TO_DASHBOARD", "Volver al panel")}
            </button>
        </div>
    {:else}
        <CreativeGenerator
            {referralLink}
            {referralCode}
            {partnerLogo}
            onClose={close}
        />
    {/if}
</section>

<style lang="scss">
    .creativityPage {
        padding: 18px 18px 0 18px;
        max-width: 1180px;
        margin: 0 auto;
        background: var(--backgroundMain);
        color: var(--textColor);
        min-height: 100vh;
    }

    .creativityPage__header {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 14px;
        align-items: start;
        margin-bottom: 12px;

        @media (max-width: 640px) {
            grid-template-columns: 1fr;
        }
    }

    .creativityPage__back {
        border: 1px solid var(--border);
        background: var(--white);
        border-radius: 999px;
        padding: 10px 12px;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        font-weight: 700;
        font-size: 13px;
        cursor: pointer;
        width: fit-content;
        color: var(--black);
    }

    .creativityPage__title h1 {
        margin: 0;
        font-size: 18px;
        font-weight: 800;
        color: var(--black);
        letter-spacing: -0.01em;
        line-height: 1.3;
    }

    .creativityPage__title p {
        margin: 6px 0 0 0;
        font-size: 13px;
        color: var(--subtleText);
        line-height: 1.35;
    }

    .creativityPage__empty {
        background: var(--white);
        border: 1px solid var(--border);
        border-radius: var(--radius);
        padding: 16px;
        display: grid;
        gap: 10px;
    }

    .creativityPage__empty h2 {
        margin: 0;
        font-size: 15px;
        font-weight: 800;
        color: var(--black);
    }

    .creativityPage__empty p {
        margin: 0;
        font-size: 13px;
        color: var(--subtleText);
        line-height: 1.35;
    }
</style>
